import { render, staticRenderFns } from "./AddFile.vue?vue&type=template&id=0e589eb1"
import script from "./AddFile.vue?vue&type=script&lang=js"
export * from "./AddFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports